import { render } from "./HomeSelector.vue?vue&type=template&id=2de86cd1"
import script from "./HomeSelector.vue?vue&type=script&lang=js"
export * from "./HomeSelector.vue?vue&type=script&lang=js"

import exportComponent from "/builds/swisscom/messaging/web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__